module.exports = {
  // 测试服务器
  api: {
    host: 'open.aquilacloud.cn',
    port: '',
    protocol: 'http'
  },
  return: ''
}
